import { Platform } from "@prisma/client";
import { TriggerCreate } from "../../libs/types/src";

const workspace = "f8c50823-cd15-45d9-ac95-f4b744b8d57d";
const communityId = "826458518675521567";
const alias = "braintrust-prod-flow-1";
const category1Id = "982324678053998662";
const category2Id = "982324679278743612";
const adminId = "";

export const braintrustTestProdCategory: any[] = [
  {
    name: "Onboarding-1",
    type: "onboarding",
    guild: communityId,
    categoryId: category1Id,
    workspace: workspace,
  },
  {
    name: "Onboarding-2",
    type: "onboarding",
    guild: communityId,
    categoryId: category2Id,
    workspace: workspace,
  },
];

const stepCommon: {
  platform: Platform;
  communityId: string;
  workspace: string;
} = {
  platform: "discord",
  communityId,
  workspace,
};

export const braintrustTestProdTrigger: TriggerCreate = {
  platform: "discord",
  communityId,
  name: "Braintrust Onboarding flow",
  workspace,
  authorUserId: "861986267902377994-826458518675521567",
  type: "team_join",
  steps: [
    {
      ...stepCommon,
      id: `${alias}-step0`,
      isEntry: true,
      type: "create_channel",
      configs: {
        channelName: "welcome-{{user.username}}",
        userIds: ["{{user.id}}"],
        isPrivate: true,
        channelType: "onboarding",
      },
      transitions: [{ targetStepId: `${alias}-step1` }],
    },
    {
      ...stepCommon,
      id: `${alias}-step1`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `Hello <@{{user.id}}> 👋 Welcome to the Braintrust. This is a quick onboarding onto the Braintrust Discord server to get you started`,
      },
      transitions: [{ targetStepId: `${alias}-step2` }],
    },
    {
      ...stepCommon,
      id: `${alias}-step2`,
      type: "send_survey",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `**What brings you to the Braintrust Network today?** Select what interests you the most:`,
        type: "buttons",
        options: [
          {
            emoji: "1️⃣",
            id: "new-talent",
            label:
              "I'm a talent interested in getting my Braintrust profile approved",
          },
          {
            emoji: "2️⃣",
            id: "approved-talent",
            label: "I'm already an Approved Talent",
          },
          {
            emoji: "3️⃣",
            id: "contributor",
            label: "I would like to be a network contributor",
          },
          {
            emoji: "4️⃣",
            id: "client",
            label: "I am a client looking to hire",
          },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-add-level0-role`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step2.messageId}}`,
            },
          },
        },
        {
          targetStepId: `${alias}-new-talent`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step2.messageId}}`,
              buttonId: "new-talent",
            },
          },
        },
        {
          targetStepId: `${alias}-approved-talent`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step2.messageId}}`,
              buttonId: "approved-talent",
            },
          },
        },
        {
          targetStepId: `${alias}-client`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step2.messageId}}`,
              buttonId: "client",
            },
          },
        },
        {
          targetStepId: `${alias}-contributor`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step2.messageId}}`,
              buttonId: "contributor",
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-add-level0-role`,
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Level 0"],
      },
      transitions: [],
    },
    {
      ...stepCommon,
      id: `${alias}-client`,
      type: "send_message",
      configs: {
        removeUrlEmbeds: true,
        channelId: `{{${alias}-step0.channelId}}`,
        message: `\n\n**Clients looking to hire can visit:**\n👉 https://www.usebraintrust.com/why-braintrust \n\nThis Discord server is also a great place to connect with the Braintrust Team and Braintrust Talent. We’ll help you find the Talent you need for your next project ASAP.\n\nDo you want to start meeting the Talent right now? They made a video for you:\n👉 https://academy.usebraintrust.com/courses/welcome-to-braintrust `,
      },
      transitions: [
        {
          targetStepId: `${alias}-step-video`,
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-new-talent`,
      type: "send_message",
      configs: {
        removeUrlEmbeds: true,
        channelId: `{{${alias}-step0.channelId}}`,
        message: `\n\nThis Discord server is where you can connect to other talented professionals in the community. They will help you on your journey to get approved and then get hired on a job with Braintrust’s top clients ASAP.\n\n**Learn more here:**\n👉 https://academy.usebraintrust.com/courses/welcome-to-braintrust`,
      },
      transitions: [
        {
          targetStepId: `${alias}-step-video`,
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-approved-talent`,
      type: "send_message",
      configs: {
        removeUrlEmbeds: true,
        channelId: `{{${alias}-step0.channelId}}`,
        message: `\n\nThis Discord server is where you can connect to other Approved Talent like you. They will help you stay informed about Braintrust Academy Courses and events that will help you land your dream job with one of Braintrust’s top Clients today!\n\n**Learn more here:**\n👉 https://academy.usebraintrust.com/courses/welcome-to-braintrust `,
      },
      transitions: [
        {
          targetStepId: `${alias}-step-video`,
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-contributor`,
      type: "send_message",
      configs: {
        removeUrlEmbeds: true,
        channelId: `{{${alias}-step0.channelId}}`,
        message: `\n\nThis Discord server is also a great place to connect with other contributors like you. They will help you on your journey to start contributing today.\n**Learn more here:**\n👉 https://academy.usebraintrust.com/courses/welcome-to-braintrust `,
      },
      transitions: [
        {
          targetStepId: `${alias}-step-video`,
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-step-video`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `💥Thank you for joining!\n\n*This channel will be auto-deleted in 48 hours. However, you can watch the Welcome to Braintrust video at your convenience from your Braintrust Platform homepage.*`,
        removeUrlEmbeds: true,
      },
      transitions: [
        {
          targetStepId: `${alias}-delete-channel`,
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-delete-channel`,
      type: "delete_channel",
      isGoal: true,
      configs: {
        delaySeconds: 60 * 60 * 48,
        channelId: `{{${alias}-step0.channelId}}`,
      },
      transitions: [],
    },
  ],
};

export {
  braintrustTestProdTrigger as trigger,
  braintrustTestProdCategory as categories,
};
